import type { AxiosInstance } from 'axios';

export class WorkspacesFileClient {
  constructor(private authenticatedClient: AxiosInstance) { }

  transcribeFile = async (data: { workspaceId: number; fileId: number }) => {
    const { workspaceId, fileId } = data;
    return this.authenticatedClient.post(`/workspaces/${workspaceId}/files/${fileId}/transcribe`, {})
      .then(res => res.data);
  };

  parseIntoTranscript = async (data: { workspaceId: number; fileId: number }) => {
    const { workspaceId, fileId } = data;
    return this.authenticatedClient.post(`/workspaces/${workspaceId}/files/${fileId}/parse-transcript`, {})
      .then(res => res.data);
  };
}

export default WorkspacesFileClient;